export default __webpack_public_path__ + "static/lightning_fast_payments-9e8a96e66b0cb7fe2212e6c18b3e8982.mp4";